<template>
    <span class="k-time" :class="skinName">{{time2text(value, template)}}</span>
</template>

<script>
    import { time2text } from '../../utils/base';
    export default {
        name: 'k-time',
        props: ['value', 'format', 'skin'],
        computed: {
            skinName() {
                return this.skin ? this.skin : ''
            },
            template() {
                const {format} = this
                return format ? format : 'M月D日hh:mm'
            }
        },
        methods: {
            time2text
        }
    };
</script>
